<template>
  <span
    class="export-pdf-button"
    :title="'export-pdf-button.title' | globalize"
  >
    <a-button
      :loading="loading"
      :type="buttonType"
      @click="() => exportToPDF(dataLoaded)"
    >
      <template v-if="!hideTitle">
        {{ 'export-pdf-button.title' | globalize }}
      </template>
      <i class="mdi mdi-file-pdf" />
    </a-button>
  </span>
</template>

<script>
import html2pdf from 'html2pdf.js'
import AButton from 'ant-design-vue/lib/button'
import AMessage from 'ant-design-vue/lib/message'
import { globalize } from '@/vue/filters/globalize'

export default {
  name: 'export-pdf-button',
  components: {
    AButton,
  },
  props: {
    documentId: {
      type: String,
      required: true,
    },
    hideTitle: {
      type: Boolean,
      default: false,
    },
    routePath: {
      type: String,
      required: true,
    },
    buttonType: {
      type: String,
      default: 'primary',
    },
    exportFromList: {
      type: Boolean,
      default: false,
    },
    dataLoaded: {
      type: Boolean,
      default: false,
    },
    beforeClick: {
      type: Function,
      default: () => {},
    },
  },

  data () {
    return {
      loading: false,
      filename: `${this.routePath.replace(/\//g, '-')}.pdf`.replace(/^-/, ''),
      exportWindow: null,
    }
  },

  methods: {
    async exportToPDF (dataLoaded) {
      this.beforeClick()

      if (!dataLoaded) return

      AMessage.warning(globalize('verification-details.exporting'))

      this.loading = true

      const parentElement = document.getElementById(this.documentId)

      await html2pdf(parentElement, {
        margin: 1,
        filename: this.filename,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2, letterRendering: true },
        pagebreak: {
          mode: '',
          before: '.break-before',
          after: '.break-after',
          avoid: '.break-avoid',
        },
        jsPDF: { unit: 'pt', format: 'letter', orientation: 'portrait' },
      })
      this.loading = false
    },
  },
}
</script>

<style lang="scss">
  @import '~ant-design-vue/lib/button/style/index.css';
  @import '~ant-design-vue/lib/message/style/index.css';

  .export-pdf-button {
    i {
      padding-left: 1em;
    }
  }
</style>
